import { BANK_REQUEST, CREATE_BANK, GET_BANKS, UPDATE_BANK, DELETE_BANK, BANK_REQUEST_FAILURE, BANK_REQUEST_SUCCESS, GET_BANKS_PAGE } from '../types';

const initialState = {
  banks: [],
  banksPage: [],
  loading: false,
  error: null,
};

const banksReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANKS: {
      return {
        ...state,
        banks: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANKS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        banksPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_BANK:
      return {
        ...state,
        banks: [action.payload, ...state.banks],
        loading: false,
        error: null
      };
    case UPDATE_BANK:
      const banksData = state.banks.slice(0);
      const uIndex = banksData.findIndex((data) => data.id === action.payload.id);
      banksData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        banks: [ ...banksData ],
        loading: false,
        error: null
      };
    case DELETE_BANK:
      const banks = state.banks?.slice(0);
      const index = banks.findIndex((data) => data.id === action.id);
      if (index > -1) {
        banks.splice(index, 1);
      }
      return {
        ...state,
        banks: [...banks],
        loading: false,
        error: null
      }
    case BANK_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case BANK_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default banksReducer;
